import React from "react";
import {updateFloorPlanLabels, revertFloorPlanLabels} from "../../util/project_api_util";

const floorName = (key, count) => {
  const n = parseInt((key.match(/\d+/) || [])[0], 10)
  return count > 1 && n ? `Floor ${n}` : "Floor plan"
}
const errorText = (xhr, fallback) => xhr?.responseJSON?.error || fallback
const idFor = (floorKey, index) => `${floorKey}:${index}`

const STYLES = `
.fplOverlay{position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:100001;display:flex;align-items:center;justify-content:center;padding:16px}
.fplModal{background:#fff;border-radius:14px;width:min(1180px,100%);height:min(820px,calc(100vh - 32px));height:min(820px,calc(100dvh - 32px));position:relative;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.25);overflow:hidden}
.fplHeader{flex:none;display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:20px 24px 12px;border-bottom:1px solid #eef0f4}
.fplHeader h3{margin:0;font-size:20px;font-weight:600;color:#0f172a}
.fplHeader p{margin:4px 0 0;font-size:14px;color:#64748b}
.fplClose{border:0;background:none;font-size:24px;line-height:1;color:#64748b;cursor:pointer;padding:0 4px}
.fplTabs{display:flex;gap:8px;padding:12px 24px 0;flex-wrap:wrap}
.fplTab{border:1px solid #d7dce5;background:#fff;border-radius:999px;padding:6px 14px;font-size:14px;cursor:pointer;color:#334155}
.fplTab.active{background:#1e2a4a;border-color:#1e2a4a;color:#fff}
.fplTab .dot{display:inline-block;width:7px;height:7px;border-radius:50%;background:#f59e0b;margin-left:6px;vertical-align:middle}
.fplBody{display:flex;gap:20px;padding:16px 24px;min-height:0;flex:1;overflow:hidden}
.fplPlan{flex:1 1 62%;min-width:0;background:#f8fafc;border:1px solid #eef0f4;border-radius:10px;padding:12px;display:flex;align-items:center;justify-content:center;overflow:auto}
.fplPlan svg{width:100%;height:100%;max-height:100%}
.fplPlan .fpLabel{cursor:pointer !important;fill:#1d4ed8 !important}
.fplPlan .fpLabel:hover{fill:#dc2626 !important;text-decoration:underline}
.fplPlan .fpLabel.changed{fill:#b45309 !important;font-weight:700}
.fplPlan .fpLabel.active{fill:#dc2626 !important;font-weight:700}
.fplList{flex:1 1 38%;min-width:280px;overflow-y:auto;padding-right:4px}
.fplHelp{background:#eff6ff;border:1px solid #bfdbfe;border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:14px;color:#1e3a8a;line-height:1.45}
.fplHelp ol{margin:4px 0 0;padding-left:18px}
.fplRead{display:flex;align-items:center;justify-content:space-between;gap:10px}
.fplName{font-size:16px;font-weight:600;color:#0f172a;letter-spacing:.02em}
.fplWas{font-size:12px;color:#b45309;margin-top:2px}
.fplEditBtn{border:1px solid #1e2a4a;background:#fff;color:#1e2a4a;border-radius:8px;padding:6px 14px;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap}
.fplEditBtn:hover{background:#1e2a4a;color:#fff}
.fplEditRow{display:flex;gap:8px}
.fplToggleRow{display:flex;align-items:center;justify-content:space-between;gap:12px;border:1px solid #e5e8ee;border-radius:10px;padding:10px 12px;margin-bottom:14px;cursor:pointer}
.fplToggleRow.changed{border-color:#f59e0b;background:#fffbeb}
.fplSwitch{flex:none;width:50px;height:28px;border-radius:999px;border:0;background:#cbd5e1;position:relative;cursor:pointer;padding:0;transition:background .15s}
.fplSwitch span{position:absolute;top:3px;left:3px;width:22px;height:22px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.25);transition:left .15s}
.fplSwitch.on{background:#16a34a}
.fplSwitch.on span{left:25px}
.fplRow.clickable{cursor:pointer}
.fplRow.clickable:hover{border-color:#1d4ed8;background:#f8faff}
.fplEditRow input{flex:1}
.fplSaving{position:absolute;inset:0;background:rgba(255,255,255,.88);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;z-index:5;border-radius:14px;font-size:16px;color:#0f172a;text-align:center;padding:24px}
.fplSpinner{width:42px;height:42px;border:4px solid #dbe3f0;border-top-color:#1e2a4a;border-radius:50%;animation:fplSpin .9s linear infinite}
@keyframes fplSpin{to{transform:rotate(360deg)}}
.fplDone{background:#fff;border-radius:14px;width:min(460px,100%);padding:32px 28px 26px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.25)}
.fplDone h3{margin:14px 0 10px;font-size:22px;font-weight:600;color:#0f172a}
.fplDone p{margin:0 0 12px;font-size:16px;line-height:1.5;color:#475569}
.fplDone .fplBtn{margin-top:10px;min-width:140px}
.fplCheck{width:56px;height:56px;border-radius:50%;background:#dcfce7;color:#16a34a;font-size:30px;line-height:56px;margin:0 auto;font-weight:700}
.fplRow{border:1px solid #e5e8ee;border-radius:10px;padding:10px 12px;margin-bottom:10px;transition:border-color .15s,box-shadow .15s}
.fplRow.active{border-color:#1d4ed8;box-shadow:0 0 0 3px rgba(29,78,216,.12)}
.fplRowTop{display:flex;justify-content:space-between;gap:8px;font-size:12px;color:#64748b;margin-bottom:6px}
.fplRowTop .orig{font-weight:600;color:#334155;letter-spacing:.02em}
.fplRow input{width:100%;border:1px solid #d7dce5;border-radius:8px;padding:8px 10px;font-size:15px;text-transform:uppercase;outline:none}
.fplRow input:focus{border-color:#1d4ed8}
.fplRow.changed input{border-color:#f59e0b;background:#fffbeb}
.fplUndo{border:0;background:none;color:#1d4ed8;font-size:12px;cursor:pointer;padding:0}
.fplFooter{flex:none;display:flex;justify-content:space-between;align-items:center;gap:12px;padding:14px 24px;border-top:1px solid #eef0f4;flex-wrap:wrap}
.fplFooter .note{font-size:13px;color:#64748b}
.fplFooter .err{font-size:14px;color:#dc2626}
.fplBtn{border-radius:8px;padding:10px 18px;font-size:15px;font-weight:600;cursor:pointer;border:1px solid #d7dce5;background:#fff;color:#1e2a4a}
.fplBtn.primary{background:#1e2a4a;border-color:#1e2a4a;color:#fff}
.fplBtn:disabled{opacity:.55;cursor:default}
.fplLink{border:0;background:none;color:#64748b;font-size:14px;text-decoration:underline;cursor:pointer;padding:0}
@media (max-width:820px){.fplOverlay{padding:0;align-items:stretch}.fplModal{width:100%;height:100vh;height:100dvh;max-height:none;border-radius:0}.fplHeader{padding:calc(14px + env(safe-area-inset-top)) 16px 10px}.fplHeader h3{font-size:18px}.fplHeader p{font-size:13px}.fplTabs{padding:10px 16px 0;flex:none;flex-wrap:nowrap;overflow-x:auto}.fplTab{white-space:nowrap}.fplBody{flex-direction:column;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:12px 16px;gap:14px}.fplPlan{flex:none;height:38vh;height:38dvh}.fplList{flex:none;overflow:visible;min-width:0}.fplFooter{padding:10px 16px calc(10px + env(safe-area-inset-bottom))}.fplFooter>div:last-child{width:100%}.fplFooter .fplBtn{flex:1}.fplDone{margin:auto 16px}}
`

export default class FloorPlanLabelsModal extends React.Component {
  constructor(props) {
    super(props)
    const data = props.data || {}
    const values = {}
    ;(data.floors || []).forEach(floor => floor.labels.forEach(l => { values[idFor(floor.key, l.index)] = l.label }))
    this.originalHideSqft = !!data.hide_square_footage
    this.state = {saving: false, error: "", floors: data.floors || [], edited: !!data.edited, values, floorIndex: 0, activeId: null, editingId: null, hideSqft: this.originalHideSqft}
    this.planRef = React.createRef()
    this.inputs = {}
  }

  componentDidMount() {
    // Lock the page behind the modal (desktop and iOS/Android).
    this.scrollY = window.scrollY
    this.prevStyles = {html: document.documentElement.style.overflow, body: document.body.style.cssText}
    document.documentElement.style.overflow = "hidden"
    document.body.style.cssText += `;overflow:hidden;position:fixed;top:-${this.scrollY}px;left:0;right:0;width:100%`
    this.bindPlan()
    this.syncPlan()
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = this.prevStyles.html
    document.body.style.cssText = this.prevStyles.body
    window.scrollTo(0, this.scrollY)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.floorIndex !== this.state.floorIndex || prevState.floors !== this.state.floors) this.bindPlan()
    this.syncPlan()
  }

  currentFloor() { return this.state.floors[this.state.floorIndex] }

  bindPlan() {
    const el = this.planRef.current
    const floor = this.currentFloor()
    if (!el || !floor) return
    el.querySelectorAll(".fpLabel").forEach(node => {
      node.onclick = () => this.focusLabel(idFor(floor.key, node.getAttribute("data-label-index")))
    })
  }

  // Keep the on-plan text in step with what the agent is typing.
  syncPlan() {
    const el = this.planRef.current
    const floor = this.currentFloor()
    if (!el || !floor) return
    el.querySelectorAll(".fpSqft").forEach(node => { node.style.display = this.state.hideSqft ? "none" : "" })
    floor.labels.forEach(l => {
      const id = idFor(floor.key, l.index)
      const node = el.querySelector(`[data-label-index="${l.index}"]`)
      if (!node) return
      const value = (this.state.values[id] || "").toUpperCase()
      if (node.textContent !== value) node.textContent = value || " "
      node.classList.toggle("changed", value.trim() !== l.original)
      node.classList.toggle("active", this.state.activeId === id)
    })
  }

  focusLabel = (id) => {
    const floorIndex = this.state.floors.findIndex(f => id.startsWith(`${f.key}:`))
    this.setState({activeId: id, editingId: id, floorIndex: floorIndex < 0 ? this.state.floorIndex : floorIndex}, () => {
      const input = this.inputs[id]
      if (input) { input.focus(); input.select(); input.scrollIntoView({block: "nearest", behavior: "smooth"}) }
    })
  }

  floorHasChanges(floor) {
    return floor.labels.some(l => (this.state.values[idFor(floor.key, l.index)] || "").trim().toUpperCase() !== l.label.toUpperCase())
  }

  changes() {
    const changes = []
    this.state.floors.forEach(floor => floor.labels.forEach(l => {
      const value = (this.state.values[idFor(floor.key, l.index)] || "").trim()
      if (value.toUpperCase() !== l.label.toUpperCase()) changes.push({floor: floor.key, index: l.index, label: value})
    }))
    return changes
  }

  sqftChanged() { return this.state.hideSqft !== this.originalHideSqft }

  pendingCount() { return this.changes().length + (this.sqftChanged() ? 1 : 0) }

  save = () => {
    const changes = this.changes()
    if (changes.length === 0 && !this.sqftChanged()) return this.props.onClose()
    if (changes.some(c => !c.label)) return this.setState({error: "Room names cannot be blank."})
    this.setState({saving: true, error: ""})
    updateFloorPlanLabels(this.props.project.id, changes, this.sqftChanged() ? this.state.hideSqft : undefined)
      .then(() => { this.props.onSaved(); this.setState({saving: false, done: "saved"}) })
      .fail(xhr => this.setState({saving: false, error: errorText(xhr, "Your changes could not be saved.")}))
  }

  revert = () => {
    this.setState({saving: true, error: ""})
    revertFloorPlanLabels(this.props.project.id)
      .then(() => { this.props.onSaved(); this.setState({saving: false, done: "restored"}) })
      .fail(xhr => this.setState({saving: false, error: errorText(xhr, "The original names could not be restored.")}))
  }

  renderList(floor) {
    const {values, activeId, editingId, saving} = this.state
    return floor.labels.map(l => {
      const id = idFor(floor.key, l.index)
      const value = values[id] || ""
      const changed = value.trim().toUpperCase() !== l.original
      const editing = editingId === id
      return <div key={id} className={`fplRow ${editing ? "" : "clickable"} ${activeId === id ? "active" : ""} ${changed ? "changed" : ""}`}
                  onMouseEnter={() => !editingId && this.setState({activeId: id})}
                  onClick={() => !editing && !saving && this.focusLabel(id)}>
        {editing ? <>
          <div className="fplRowTop"><span>Type the new name{l.dimension ? ` (${l.dimension})` : ""}</span></div>
          <div className="fplEditRow">
            <input ref={el => { this.inputs[id] = el }} value={value} maxLength={40} disabled={saving} autoFocus
                   onChange={e => this.setState({values: {...values, [id]: e.target.value}})}
                   onKeyDown={e => { if (e.key === "Enter") this.setState({editingId: null}) }}/>
            <button className="fplEditBtn" onClick={() => this.setState({editingId: null})}>Done</button>
          </div>
        </> : <div className="fplRead">
          <div>
            <div className="fplName">{(value || l.original).toUpperCase()}</div>
            <div className="fplRowTop" style={{margin: 0}}>{l.dimension || ""}</div>
            {changed && <div className="fplWas">Was {l.original}</div>}
          </div>
          <button className="fplEditBtn" disabled={saving} onClick={e => { e.stopPropagation(); this.focusLabel(id) }}>✎ Edit</button>
        </div>}
      </div>
    })
  }

  renderDone() {
    const emails = this.props.project?.status === "complete"
    return (
      <div className="fplOverlay" onClick={this.props.onClose}>
        <style>{STYLES}</style>
        <div className="fplDone" onClick={e => e.stopPropagation()}>
          <div className="fplCheck">✓</div>
          <h3>{this.state.done === "restored" ? "Original floor plan restored" : "Your floor plan is updated"}</h3>
          <p>The new floor plan images and PDF are already on your project page.</p>
          <p>{emails
            ? <>We're preparing your download folder now. <strong>You'll receive an email in a few minutes</strong> when it's ready to download.</>
            : <>We're preparing your download folder now. The <strong>Download</strong> button will be ready in a few minutes.</>}</p>
          <button className="fplBtn primary" onClick={this.props.onClose}>Got it</button>
        </div>
      </div>
    )
  }

  render() {
    if (this.state.done) return this.renderDone()
    const {saving, error, floors, edited, floorIndex} = this.state
    const floor = this.currentFloor()
    const pending = this.pendingCount()
    return (
      <div className="fplOverlay" onClick={() => !saving && this.props.onClose()}>
        <style>{STYLES}</style>
        <div className="fplModal" onClick={e => e.stopPropagation()}>
          {saving && <div className="fplSaving"><div className="fplSpinner"/>
            <div><strong>Updating your floor plan…</strong><br/>This takes a few seconds. Please keep this window open.</div></div>}
          <div className="fplHeader">
            <div>
              <h3>Edit room names</h3>
              <p>Change what each room is called. Room sizes and square footage stay exactly as measured.</p>
            </div>
            <button className="fplClose" aria-label="Close" onClick={() => !saving && this.props.onClose()}>×</button>
          </div>

          {!floor ? <div className="fplBody"><p>{error || "No editable room names were found."}</p></div>
            : <>
              {floors.length > 1 && <div className="fplTabs">
                {floors.map((f, i) => <button key={f.key} className={`fplTab ${i === floorIndex ? "active" : ""}`}
                                              onClick={() => this.setState({floorIndex: i, activeId: null})}>
                  {floorName(f.key, floors.length)}{this.floorHasChanges(f) && <span className="dot"/>}
                </button>)}
              </div>}
              <div className="fplBody">
                <div className="fplPlan" ref={this.planRef} key={floor.key} dangerouslySetInnerHTML={{__html: floor.svg}}/>
                <div className="fplList">
                  <div className="fplHelp"><strong>How to rename a room</strong>
                    <ol>
                      <li>Click <strong>✎ Edit</strong> next to a room, or click its blue name on the plan.</li>
                      <li>Type the new name and press <strong>Done</strong>.</li>
                      <li>Click <strong>Save room names</strong> at the bottom.</li>
                    </ol>
                  </div>
                  <div className={`fplToggleRow ${this.sqftChanged() ? "changed" : ""}`} onClick={() => !saving && this.setState({hideSqft: !this.state.hideSqft})}>
                    <div>
                      <div className="fplName" style={{fontSize: 15}}>Show square footage</div>
                      <div className="fplRowTop" style={{margin: 0}}>The totals under every plan. The disclaimer always stays.</div>
                    </div>
                    <button type="button" role="switch" aria-checked={!this.state.hideSqft} className={`fplSwitch ${this.state.hideSqft ? "" : "on"}`} disabled={saving}>
                      <span/>
                    </button>
                  </div>
                  {this.renderList(floor)}
                </div>
              </div>
            </>}

          <div className="fplFooter">
            <div>
              {error && floor ? <span className="err">{error}</span>
                : edited ? <button className="fplLink" disabled={saving} onClick={this.revert}>Restore original floor plan</button>
                : <span className="note">{pending ? `${pending} change${pending > 1 ? "s" : ""} ready to save` : "No changes yet"}</span>}
            </div>
            <div className="d-flex" style={{gap: 10}}>
              <button className="fplBtn" disabled={saving} onClick={this.props.onClose}>Cancel</button>
              {floor && <button className="fplBtn primary" disabled={saving || pending === 0} onClick={this.save}>
                {saving ? "Updating floor plan…" : "Save room names"}
              </button>}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
